import { useState } from "react";
import About from "./About";
import Home from "./Home";
import Contact from "./Contact";
import EducationCertificate from "./EducationCertificate";
import Experience from "./Experience";
import Project from "./Project";
import {Link} from "react-scroll"
import "../App.css"

function NavigationBar() {
    const [menuOpen, setMenuOpen] = useState(false)
    const closeMenu = () => setMenuOpen(false)

    return (
        <div className="App">
            <header className="nav">
                <nav className="nav__container__actions">
                    <Link className="logo-nav" activeClass="active" smooth spy to="home" offset={-70} onClick={closeMenu}>
                        <img className="logo-image" src={require("../assets/images/noppakun_web_portfolio_logo.png")} alt="" />
                    </Link>
                    <div className={menuOpen ? "nav-links-open" : ""}>
                        <ul>
                            <li className="section-nav">
                                <Link activeClass="active" smooth spy to="projects" onClick={closeMenu}>
                                    Projects
                                </Link>
                            </li>
                            <li className="section-nav">
                                <Link activeClass="active" smooth spy to="experience" onClick={closeMenu}>
                                    Experience
                                </Link>
                            </li>
                            <li className="section-nav">
                                <Link activeClass="active" smooth spy to="about" onClick={closeMenu}>
                                    About
                                </Link>
                            </li>
                            <li className="section-nav">
                                <Link activeClass="active" smooth spy to="education" onClick={closeMenu}>
                                    Education & Certificates
                                </Link>
                            </li>
                            <li className="section-nav">
                                <Link activeClass="active" smooth spy to="contact" onClick={closeMenu}>
                                    Contact
                                </Link>
                            </li>
                            {/* public/Noppakun_Anantakitthawon_iOS_Developer.pdf — last synced from
                                Noppakun_Resume_2026.pdf on 2026-07-28. Re-copy after every résumé edit. */}
                            <li className="section-nav">
                                <a className="nav-resume-btn" href="/Noppakun_Anantakitthawon_iOS_Developer.pdf" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
                                    Résumé (PDF)
                                </a>
                            </li>
                        </ul>
                    </div>

                    <button
                        className="hamburger"
                        onClick={() => setMenuOpen((open) => !open)}
                        aria-expanded={menuOpen}
                        aria-label={menuOpen ? "Close menu" : "Open menu"}
                    >
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                    </button>
                </nav>
            </header>
            <section id="home">
                <Home />
            </section>
             <section id="projects" className="item-section">
                <Project />
             </section>
             <section id="experience" className="item-section">
                <Experience />
             </section>
             <section id="about" className="item-section">
                <About />
             </section>
             <section id="education" className="item-section">
                <EducationCertificate />
             </section>
             <section id="contact" className="item-section">
                <Contact />
             </section>
        </div>
    );
}

export default NavigationBar
